import { Injectable, Inject } from '@angular/core';
import { BP_CONFIG, BpConfig } from './bp.config';

@Injectable({
  providedIn: 'root'
})
export class BpConfigService {

  constructor(@Inject(BP_CONFIG) private config: BpConfig) {}

  getConfig(): BpConfig {
    return this.config;
  }
}
